module.exports = __webpack_public_path__ + "static/media/6.dc6f5179.jpg";